<template>
<b-tab lazy title-item-class="mr-1" :title-link-class="{'bg-danger': hasErrors, 'bg-warning': isDirty}">
    <template slot="title">
        <i v-if="isDirty || hasErrors" class="fa-solid fa-circle-exclamation" :class="{ 'fa-circle-exclamation text-white': hasErrors, 'fa-cloud-arrow-up text-black': isDirty}"></i> Vital Functions
    </template>
    <vital-functions-base button-top small fixed :callback="createPatientAdminVitals" />
</b-tab>
</template>
<script>
import TabExtension from "../TabExtension"
import VitalFunctionsBase from "@/core/components/health/vitalfunctions/VitalFunctionsBase"
import { mapActions } from "vuex"

export default TabExtension.extend({
    name: "vital-functions",
    components: {
        'vital-functions-base': VitalFunctionsBase
    },
    methods: {
        ...mapActions('health', ['createPatientAdminVitals']),
    }
})
</script>